import { render, staticRenderFns } from "./ControlOption.vue?vue&type=template&id=08f8ccd9"
import script from "./ControlOption.vue?vue&type=script&lang=js"
export * from "./ControlOption.vue?vue&type=script&lang=js"
import style0 from "./ControlOption.vue?vue&type=style&index=0&id=08f8ccd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports